var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tour',{attrs:{"steps":_vm.tourSteps,"callbacks":_vm.customCallbacks,"data-cy":"leave-dates-tour","name":"leave-dates-tour"}})
}
var staticRenderFns = []

export { render, staticRenderFns }